import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Form } from 'antd';
import Button from './Button';
import ColumnSeparator from '../layout/ColumnSeparator';
import Icon from '../layout/Icon';

const Tags = props => (
  <Form.Item label={props.label} help={props.errorText} validateStatus={props.errorText && 'error'}>
    <div>
      {props.tags.map(tag => (
        <>
          <Tag key={`tag-${tag.index}`} closable={false}>
            {!props.disabled && tag.canRollback && (
              <Icon
                name="rollback"
                style={{ color: tag.canRollback ? props.color : 'inherit' }}
                onClick={() => props.onClick(tag.index, tag)}
              />
            )}
            {!props.disabled && tag.canDelete && <Icon name="close" onClick={() => props.onDelete(tag.index, tag)} />}
            <ColumnSeparator size="xs" />
            <span style={{ color: tag.canRollback ? props.color : 'inherit' }}>{tag.text}</span>
          </Tag>
          {!props.disabled && tag.canLink && (
            <>
              <Button size="sm" disabled={props.disabled} icon="link" onClick={() => props.onLink(tag.index, tag)} />
              <ColumnSeparator size="xs" />
            </>
          )}
          {!props.disabled && tag.isLinked && (
            <>
              <Icon name="line" style={{ color: props.color }} />
              <ColumnSeparator size="xs" />
            </>
          )}
        </>
      ))}
    </div>
  </Form.Item>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      text: PropTypes.string,
      icon: PropTypes.string,
      canDelete: PropTypes.bool,
      canRollback: PropTypes.bool,
      canLink: PropTypes.bool,
      isLinked: PropTypes.bool,
    })
  ),
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onLink: PropTypes.func.isRequired,
  color: PropTypes.string,
};

Tags.defaultProps = {
  tags: [],
  disabled: false,
  errorText: null,
  color: 'inherit',
};

export default Tags;
